/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import ActionFeedbackBackgroundCircleSvg from 'bundles/video-player/assets/svg/ActionFeedbackBackgroundCircleSvg';

const styles = {
  playButtonContainer: css`
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease-in-out, visibility 0.4s ease-in-out;
    opacity: 0;
    visibility: hidden;
  `,
  showActionFeedback: css`
    opacity: 1;
    visibility: visible;
  `,
  hideActionFeedback: css`
    opacity: 0;
    visibility: hidden;
  `,
  actionFeedbackIconContainer: css`
    position: relative;
    width: 124px;
    height: 124px;
  `,
  actionFeedbackBackground: css`
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1);
  `,
  actionFeedbackIcon: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
};

export type VideoFeedbackState = {
  icon: JSX.Element;
};

type Props = {
  feedback?: VideoFeedbackState;
  showFeedback: boolean;
};

const ActionFeedback: React.FC<Props> = ({ feedback, showFeedback }) => {
  return (
    <div
      role="presentation"
      className={`action-feedback ${showFeedback ? 'show' : 'hide'}`}
      data-testid="action-feedback-container"
      css={[styles.playButtonContainer, showFeedback ? styles.showActionFeedback : styles.hideActionFeedback]}
    >
      {feedback && (
        <div css={styles.actionFeedbackIconContainer} data-testid="action-feedback-icon-container">
          <ActionFeedbackBackgroundCircleSvg css={styles.actionFeedbackBackground} />
          <div css={styles.actionFeedbackIcon}>{feedback.icon}</div>
        </div>
      )}
    </div>
  );
};

export default ActionFeedback;
